import type { RouteRecordRaw } from 'vue-router'
import type { PageDefinition } from '@/types/page'
import { PAGE_DEFINITIONS, normalizePath } from '@/data/registry'
import PageHost from '@/views/PageHost.vue'
import StateView from '@/views/StateView.vue'

function pageRoute(page: PageDefinition): RouteRecordRaw {
  return {
    path: normalizePath(page.route),
    name: page.id,
    component: PageHost,
    meta: {
      pageId: page.id,
      title: page.title,
      group: page.group,
      permission: page.permission,
      public: page.permission === 'public',
      requiresAuth: page.permission !== 'public',
      state: page.kind === 'state' ? page.id : undefined,
      layout: page.id === 'login' ? 'blank' : undefined,
    },
  }
}

/**
 * The single route table. Menus, breadcrumbs, tabs, search and permission
 * guards all derive from the same PageDefinition registry.
 */
export function buildRoutes(): RouteRecordRaw[] {
  return [
    { path: '/', redirect: '/dashboard' },
    ...PAGE_DEFINITIONS.map(pageRoute),
    {
      path: '/:pathMatch(.*)*',
      name: 'unknown-route',
      component: StateView,
      props: route => ({ kind: 'not-found', unknownPath: route.fullPath }),
      meta: { title: '页面不存在', public: true, requiresAuth: false },
    },
  ]
}

export { pageRoute }
